module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-sm-6 col-xs-5"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sm"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'config.estado-veiculo.list'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Lista")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'config.estado-veiculo.novo'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cadastro")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-7"
  }, [_c('div', {
    staticClass: "m-t-sm"
  }, [_vm._v("Administração de Estados de Veículo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184af3be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/veiculo/estado-veiculo/components/Header.vue
// module id = 1711
// module chunks = 18